import { api } from "../api";

export const EmailService = {
    enviarEmail: async (data) => {
        const response = await api.post("/email", data);

        return response.data;
    }
}; 